import { useEffect } from 'react';

/**
 * What the person has open, for the assistant to be told with each question:
 * the fund or portfolio company in the docked pane. A pane says so while it is
 * mounted; nothing re-renders on it, because it is only read at send time.
 */
export interface AssistantFocus {
  fundId?: string;
  companyId?: string;
}

let focus: AssistantFocus = {};

export function currentFocus(): AssistantFocus {
  return focus;
}

export function useAssistantFocus(kind: keyof AssistantFocus, id: string | null): void {
  useEffect(() => {
    if (id === null) return;
    focus = { ...focus, [kind]: id };
    return () => {
      if (focus[kind] !== id) return;
      const next = { ...focus };
      delete next[kind];
      focus = next;
    };
  }, [kind, id]);
}
